export default {
    type: 'hero-carousel',
    name: 'Hero',
    osOnly: false,
    components: {
        root: {
            name: 'ModuleHero',
            loader: () => import('./ModuleHero')
        },
        form: {
            name: 'ModuleHeroForm',
            loader: () => import('./ModuleHeroForm')
        }
    }
};
